import React from "react";
import Icons from "components/icons";
import { Localize } from "components/service";

interface IEmailChannelEmptyStateProps {
  action: React.ReactNode;
}

const EmailChannelEmptyState: React.FC<IEmailChannelEmptyStateProps> = ({
  action,
}) => (
  <div className="email-channel-empty-state">
    <Icons.NoChannels className="email-channel-empty-state-icon" />
    <strong className="email-channel-empty-state-title">
      <Localize>EMAIL_CHANNEL.Empty_Title</Localize>
    </strong>
    <p className="email-channel-empty-state-description">
      <Localize>EMAIL_CHANNEL.Empty_Text</Localize>
    </p>
    <div className="email-channel-empty-state-action">{action}</div>
  </div>
);

export default EmailChannelEmptyState;
